import useAppSelector from '../../hooks/useAppSelector';
import SidebarFeature from '../sidebar/SidebarFeature';
import FiltersPanel from '../filters/FiltersPanel';
import MainFeature from '../main/MainFeature';
import AssistantHeader from './header/AssistantHeader';
import './AssistantWindow.less';

const AssistantWindow = () => {
    const { mode, position } = useAppSelector(state => state.uiState);
    const { sidebarExpanded } = useAppSelector(state => state.featureState);
    return (
        <>
            <div
                className={`bri-AssistantWindow bri-AssistantWindow-position-${position}
                bri-AssistantWindow-mode-${mode}
                ${sidebarExpanded ? 'bri-sidebar-expanded' : ''}`}
            >
                <div className={`bri-AssistantWindow-header`}>
                    <AssistantHeader />
                </div>
                <div className={`bri-AssistantWindow-body`}>
                    <div className={`bri-AssistantWindow-main`}>
                        <MainFeature />
                    </div>
                    <div className={`bri-AssistantWindow-sidebar`}>
                        <SidebarFeature />
                    </div>
                </div>
                <FiltersPanel />
            </div>
        </>
    );
};

export default AssistantWindow;
